import { useReduxSelector } from '../../../hooks';
import { rootStateBranchSelector } from '../../../utils/rootStateBranchSelector';
import type { ChatState } from '../slice';

export const chatSelector = rootStateBranchSelector('chat');

export function useChatSelector(): ChatState {
  return useReduxSelector(chatSelector);
}
